import { createNamedWrapperReducer, isActionRelated } from '@core/utils/state';
import { IEntitiesState } from '../shared/entities/entities-state';
import {
    IUsersState,
    initialUsersState
} from './users-state';
import { reducer as listReducer } from '../shared/list/reducer';
import { GROUP_USERS } from '../state-groups';
import { USERS_FETCH } from '../action-types';

export function reducer(
    state: IUsersState = initialUsersState(),
    action: any,
    entitySlice: IEntitiesState): IUsersState {        
      
    switch (action.type) {

        case USERS_FETCH:
            return {
                ...state,
                users: {
                    ...state.users,
                    isFetching: true
                }
            };

        default:
            let nextState: IUsersState = state;

            if (isActionRelated(action, GROUP_USERS)) {
                nextState = {
                    ...state,
                    users: createNamedWrapperReducer(
                        listReducer,
                        GROUP_USERS
                    )(state.users, action, entitySlice.entities),
                };
            }

            return nextState;
    }
}
